import { createFileRoute } from '@tanstack/react-router'

import { VehicleDetailPage } from '@/components/vehicles/vehicle-detail-page'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/vehicles/$vehicleId',
)({
    component: VehicleDetailRoute,
})

function VehicleDetailRoute() {
    const { vehicleId } = Route.useParams()
    return <VehicleDetailPage vehicleId={vehicleId} />
}
